import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
import { useNavigate } from "react-router-dom";
const Newsletter = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <Breadcrumb title="Newsletter" tabName="Newsletter" />
      <div className="innerPage">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-6 col-sm-12 mb-3">
              <p className="magazinebg">
                <b>
                  Introducing ‘Nirmal Sparks’ - A Showcase of Student Editorial
                  Excellence
                </b>
              </p>
              <p>
                Our school thrives on a pulse of energy—the giggles echoing in
                the kindergarten wing, the sparks of discovery in the middle
                grades, and the bold aspirations of our senior learners. To
                celebrate this spirit, the Commerce & Humanities Department has
                introduced an exciting new venture: a Quarterly School
                Newsletter crafted from start to finish by the creative minds of
                our students. It is a canvas of voices, a gallery of moments,
                and a celebration of learning from Nursery to Grade 12.
                <br />
                <br />
                What makes it truly inspiring is the team behind it. <br />{" "}
                <br />
                Our Commerce and Humanities students step into the roles of
                young journalists, photographers, editors, designers,
                coordinators—and above all, storytellers. They roam the school
                grounds with notebooks and cameras, collecting memories,
                interviewing classmates, capturing achievements, and
                transforming raw moments into polished stories. <br /> <br />
                Every edition is a journey— from idea to storyboard, from
                photographs to layouts, from drafts to the final publication. It
                is here that students learn the art of communication, the
                discipline of deadlines, the creativity of design, and the joy
                of teamwork. <br /> <br />
                This initiative is our way of saying: <br /> <br />
                Every child has a story. Every story deserves a voice. And
                together, our students bring those voices to life.
              </p>
            </div>
            <div className="col-lg-5 col-md-6 col-sm-12 mb-3">
              <p className="magazine_blk_p">Nirmal Sparks Vol - III</p>
              <div className="magazine_blk active">
                <a
                  target="_blank"
                  onClick={() =>
                    navigate("/newsletter3", { state: { newsletter: "news1" } })
                  }
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/news_letter_3_1.jpg"
                    className="magazine-block img-fluid"
                  />
                  <button className="mt-4">View</button>
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6">
              <p className="magazine_blk_p">Nirmal Sparks Vol - II</p>
              <div className="magazine_blk">
                <a
                  target="_blank"
                  onClick={() =>
                    navigate("/newsletter2", { state: { newsletter: "news1" } })
                  }
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter2.JPG"
                    className="magazine-block img-fluid"
                  />
                  <button className="mt-4">View</button>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <p className="magazine_blk_p">Nirmal Sparks Vol - I</p>
              <div className="magazine_blk">
                <a
                  target="_blank"
                  onClick={() =>
                    navigate("/newsletter1", { state: { newsletter: "news1" } })
                  }
                >
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/newsletter/newsletter1.jpg"
                    className="magazine-block img-fluid"
                  />
                  <button className="mt-4">View</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Newsletter;
